import { useState } from 'react';
import { GlobalContext } from '@/utils/globalContext';

// 创建一个 Provider 组件，用来提供全局状态
const GlobalProvider = (props: any) => {
    const { children } = props;
    const [appLang, setAppLang] = useState('en-us');
    const [globalAppid, setGlobalAppid] = useState<any>('');
    const [globalProps, setGlobalProps] = useState<object>({ appLang });
    const [globalSite, setGlobalSite] = useState<string>('');
    const [creditsRefresh, setCreditsRefresh] = useState<string>('');
    const store = {
        appLang,
        setAppLang,
        globalProps,
        setGlobalProps,
        globalAppid,
        setGlobalAppid,
        globalSite,
        setGlobalSite,
        creditsRefresh,
        setCreditsRefresh,
    };
    return <GlobalContext.Provider value={store}>{children}</GlobalContext.Provider>;
};

export default GlobalProvider;
